export const laoC = [
  [
    [113.68050643012454, 23.014078043914996, 10],
    [113.68049014992737, 23.014087996074505, 10],
  ],
  [
    [113.6805538344569, 23.01415944120023, 10],
    [113.68053520502613, 23.01416480539016, 10],
  ],
  [
    [113.68057986691413, 23.014247059803132, 10],
    [113.6805608572498, 23.01425112329446, 10],
  ],
  [
    [113.68059163615251, 23.014339020200723, 10],
    [113.6805722840235, 23.014336727724356, 10],
  ],
  [
    [113.68057298369388, 23.014429488217, 10],
    [113.68055476428748, 23.014423028979117, 10],
  ],
  [
    [113.6805329836746, 23.014513269062693, 10],
    [113.68051620514561, 23.014504053261216, 10],
  ],
  [
    [113.68047778850321, 23.01458800490348, 10],
    [113.68046173823693, 23.014577737637815, 10],
  ],
  [
    [113.68042227276757, 23.014663739621465, 10],
    [113.68040835622635, 23.01465108242932, 10],
  ],
  [
    [113.68036048641814, 23.0147306909416, 10],
    [113.68034418256515, 23.014720771911644, 10],
  ],
  [
    [113.68030844766332, 23.014807102881946, 10],
    [113.68029225674222, 23.014797026584695, 10],
  ],
  [
    [113.68025185828837, 23.014880927786248, 10],
    [113.68023598393657, 23.01487042875197, 10],
  ],
  [
    [113.68019339464774, 23.014953480786478, 10],
    [113.6801778765654, 23.014942534873366, 10],
  ],
  [
    [113.68013594805535, 23.01502265230074, 10],
    [113.68011740926774, 23.01501702513274, 10],
  ],
  [
    [113.68008563758029, 23.015086701543414, 10],
    [113.68007090557775, 23.015074861433295, 10],
  ],
  [
    [113.68001979971373, 23.015154018871442, 10],
    [113.68000587483326, 23.015141369494007, 10],
  ],
  [
    [113.67995147318327, 23.015218467190262, 10],
    [113.67993754828308, 23.015205817825315, 10],
  ],
  [
    [113.67988314666592, 23.015282915497334, 10],
    [113.67986922178503, 23.015270266108086, 10],
  ],
  [
    [113.67981481999585, 23.015347363765006, 10],
    [113.67980089511475, 23.01533471436984, 10],
  ],
  [
    [113.67974649336803, 23.015411811903206, 10],
    [113.67973256846757, 23.015399162520186, 10],
  ],
  [
    [113.67968011439606, 23.015477461522664, 10],
    [113.67966566757909, 23.01546532400593, 10],
  ],
  [
    [113.67961242204238, 23.01554226777054, 10],
    [113.67959787794805, 23.015530230201428, 10],
  ],
  [
    [113.67954940750582, 23.015610202609793, 10],
    [113.67953385173983, 23.015599302533975, 10],
  ],
  [
    [113.67949081896447, 23.015681858172737, 10],
    [113.67947481494386, 23.015671529067816, 10],
  ],
  [
    [113.67943579702761, 23.015755140802042, 10],
    [113.67941869688563, 23.015746446005455, 10],
  ],
  [
    [113.6793899672721, 23.01583397558064, 10],
    [113.67937216726064, 23.015826581582388, 10],
  ],
  [
    [113.67934911152061, 23.015915995664237, 10],
    [113.67933133570972, 23.015908551926657, 10],
  ],
  [
    [113.67930845253164, 23.01599899338469, 10],
    [113.6792915162874, 23.01599002788471, 10],
  ],
  [
    [113.67925426083958, 23.016075692377264, 10],
    [113.67923928803515, 23.016064113862356, 10],
  ],
  [
    [113.67918964539001, 23.0161441867679, 10],
    [113.67917566761432, 23.016131587382215, 10],
  ],
  [
    [113.67912170562668, 23.01620890547708, 10],
    [113.67910764245606, 23.01619638777126, 10],
  ],
  [
    [113.6790544530092, 23.01627423139872, 10],
    [113.67904030114919, 23.016261799624026, 10],
  ],
  [
    [113.67898706707791, 23.01633966824683, 10],
    [113.67897307313444, 23.016327084229133, 10],
  ],
  [
    [113.67891864485715, 23.0164040959629, 10],
    [113.67890472602149, 23.016391440767915, 10],
  ],
  [
    [113.67885121827378, 23.016469156033356, 10],
    [113.67883710041431, 23.016456691159867, 10],
  ],
  [
    [113.67878287155047, 23.016534060046123, 10],
    [113.6787692900871, 23.01652109456398, 10],
  ],
  [
    [113.67871412115676, 23.016597406638144, 10],
    [113.67869979045767, 23.016585151624795, 10],
  ],
  [
    [113.67864820710615, 23.016664297602546, 10],
    [113.67863425638362, 23.016651672502533, 10],
  ],
  [
    [113.67857893633843, 23.016726763569086, 10],
    [113.67856395950086, 23.01671518944599, 10],
  ],
  [
    [113.67851447257607, 23.01679530921267, 10],
    [113.67850039924753, 23.0167828012349, 10],
  ],
  [
    [113.67844687415379, 23.016860477115255, 10],
    [113.67843287038856, 23.01684790241253, 10],
  ],
  [
    [113.6783786832078, 23.016925140425588, 10],
    [113.6783647794598, 23.016912470978863, 10],
  ],
  [
    [113.67831133566929, 23.016990370111, 10],
    [113.67829734308447, 23.016977784736298, 10],
  ],
  [
    [113.67824151199717, 23.017052258927965, 10],
    [113.67822649419428, 23.01704073033612, 10],
  ],
  [
    [113.67817615265002, 23.01712013327872, 10],
    [113.67816213770617, 23.017107569226226, 10],
  ],
  [
    [113.67810796103686, 23.017184843033125, 10],
    [113.6780940978242, 23.017172135559658, 10],
  ],
  [
    [113.6780391672329, 23.01724903144496, 10],
    [113.67802548565443, 23.017236156401914, 10],
  ],
  [
    [113.67796981057693, 23.017312518503275, 10],
    [113.6779561161987, 23.017299655119256, 10],
  ],
  [
    [113.67789933240546, 23.017375475258326, 10],
    [113.67788623010095, 23.017362093904644, 10],
  ],
  [
    [113.67782633719298, 23.017435919526847, 10],
    [113.67781383456878, 23.01742205529658, 10],
  ],
  [
    [113.67775127119766, 23.017493638913756, 10],
    [113.6777388226413, 23.017479733056163, 10],
  ],
  [
    [113.67767456764913, 23.017550575394694, 10],
    [113.67766337761456, 23.017535781383245, 10],
  ],
  [
    [113.67759299447958, 23.017600879544432, 10],
    [113.67758269731257, 23.01758554002324, 10],
  ],
  [
    [113.6775086961346, 23.017647256621927, 10],
    [113.67749933365874, 23.017631412209514, 10],
  ],
  [
    [113.6774215254175, 23.01768887281299, 10],
    [113.67741322971625, 23.017672527006944, 10],
  ],
  [
    [113.6773331035402, 23.01772755204647, 10],
    [113.67732533756224, 23.01771098474957, 10],
  ],
  [
    [113.67724385270073, 23.017764820910617, 10],
    [113.67723680530865, 23.017747980608437, 10],
  ],
  [
    [113.67715360902636, 23.017798098215533, 10],
    [113.67714581096729, 23.017781543833635, 10],
  ],
  [
    [113.67706435978629, 23.017834584246245, 10],
    [113.67705659632136, 23.017818015938087, 10],
  ],
  [
    [113.67697399815002, 23.017868827583285, 10],
    [113.67696646558832, 23.017852168201294, 10],
  ],
  [
    [113.67688439722305, 23.01790447547996, 10],
    [113.67687682856807, 23.01788783011944, 10],
  ],
  [
    [113.67679442234407, 23.017939292638008, 10],
    [113.67678680929441, 23.01792266463231, 10],
  ],
  [
    [113.67670493076477, 23.017974103791353, 10],
    [113.67669644711802, 23.017957840840293, 10],
  ],
  [
    [113.67661521858795, 23.018011475423908, 10],
    [113.67660835104017, 23.017994571575947, 10],
  ],
  [
    [113.67652449253661, 23.018043702236668, 10],
    [113.67651695909005, 23.01802704319428, 10],
  ],
  [
    [113.67643437166541, 23.01807854815424, 10],
    [113.67642705619734, 23.018061806082564, 10],
  ],
  [
    [113.67634522665244, 23.018115066222627, 10],
    [113.67633791309825, 23.01809832343391, 10],
  ],
  [
    [113.67625495851716, 23.018149012021794, 10],
    [113.67624743121158, 23.018132350599235, 10],
  ],
  [
    [113.67616516956903, 23.018184124085092, 10],
    [113.67615749836064, 23.0181675189923, 10],
  ],
  [
    [113.67607569216122, 23.018219591608165, 10],
    [113.67606763135169, 23.018203145404375, 10],
  ],
  [
    [113.67598632988226, 23.018256581126252, 10],
    [113.67597889186749, 23.018239885378883, 10],
  ],
  [
    [113.67589668351442, 23.018291403693116, 10],
    [113.67588864682504, 23.018274947376895, 10],
  ],
  [
    [113.67580803946177, 23.018329439200006, 10],
    [113.67580030058964, 23.018312861027216, 10],
  ],
  [
    [113.67571954005678, 23.018366049049842, 10],
    [113.67571072742757, 23.018349936676785, 10],
  ],
  [
    [113.67563355696305, 23.018407632973755, 10],
    [113.67562382845378, 23.018391978615767, 10],
  ],
  [
    [113.67554940423388, 23.018453366007535, 10],
    [113.67553974467349, 23.01843767510798, 10],
  ],
  [
    [113.67546372617211, 23.018496634281604, 10],
    [113.6754542372941, 23.01848085440055, 10],
  ],
  [
    [113.67537991712031, 23.0185420049669, 10],
    [113.67536968587709, 23.018526627658986, 10],
  ],
  [
    [113.67529761400709, 23.018589252892376, 10],
    [113.67528625191075, 23.018574571623486, 10],
  ],
  [
    [113.67521703398921, 23.01864029345488, 10],
    [113.67520585723875, 23.018625490786828, 10],
  ],
  [
    [113.67513857858013, 23.018693018247077, 10],
    [113.67512651013908, 23.018678828115192, 10],
  ],
  [
    [113.67506120947905, 23.018748256763512, 10],
    [113.6750494025833, 23.018733879344673, 10],
  ],
  [
    [113.67498489455085, 23.01880384795075, 10],
    [113.6749724322613, 23.018789952547582, 10],
  ],
  [
    [113.67491025424599, 23.01886154931217, 10],
    [113.67489733194587, 23.01884801870153, 10],
  ],
  [
    [113.67483607941395, 23.018920903334404, 10],
    [113.67482395246698, 23.018906755988503, 10],
  ],
  [
    [113.67476051225668, 23.018977603798778, 10],
    [113.67474797008171, 23.01896377010347, 10],
  ],
];
